// ⚠️⚠️⚠️⚠️ DO NOT EDIT ⚠️⚠️⚠️⚠️
// This file was automatically generated, run pnpm gen:gql to update it
/* eslint-disable */

import type * as Types from '../../../../../schema/public';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type MyLoyaltyStatusSidebarQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type MyLoyaltyStatusSidebarQuery = { __typename?: 'Query', loyaltyPublic?: { __typename?: 'LoyaltyPublic', id?: string, myStatus?: { __typename?: 'LoyaltyPublicMyStatus', id?: string, tierPoints?: number, currentTier?: { __typename?: 'LoyaltyPublicUserTier', id: string, logoUrl?: string, imageUrl?: string, name?: string }, nextMilestone?: { __typename?: 'LoyaltyPublicMilestone', id: string, points?: string, progress?: number } } } };


export const MyLoyaltyStatusSidebarDocument = /*#__PURE__*/ gql`
    query MyLoyaltyStatusSidebar {
  loyaltyPublic {
    id
    myStatus {
      id
      tierPoints
      currentTier {
        id
        logoUrl
        imageUrl
        name
      }
      nextMilestone {
        id
        points
        progress
      }
    }
  }
}
    `;
export function useMyLoyaltyStatusSidebarQuery(baseOptions?: Apollo.QueryHookOptions<MyLoyaltyStatusSidebarQuery, MyLoyaltyStatusSidebarQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyLoyaltyStatusSidebarQuery, MyLoyaltyStatusSidebarQueryVariables>(MyLoyaltyStatusSidebarDocument, options);
      }
export function useMyLoyaltyStatusSidebarLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyLoyaltyStatusSidebarQuery, MyLoyaltyStatusSidebarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyLoyaltyStatusSidebarQuery, MyLoyaltyStatusSidebarQueryVariables>(MyLoyaltyStatusSidebarDocument, options);
        }
export function useMyLoyaltyStatusSidebarSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyLoyaltyStatusSidebarQuery, MyLoyaltyStatusSidebarQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyLoyaltyStatusSidebarQuery, MyLoyaltyStatusSidebarQueryVariables>(MyLoyaltyStatusSidebarDocument, options);
        }
export type MyLoyaltyStatusSidebarQueryHookResult = ReturnType<typeof useMyLoyaltyStatusSidebarQuery>;
export type MyLoyaltyStatusSidebarLazyQueryHookResult = ReturnType<typeof useMyLoyaltyStatusSidebarLazyQuery>;
export type MyLoyaltyStatusSidebarSuspenseQueryHookResult = ReturnType<typeof useMyLoyaltyStatusSidebarSuspenseQuery>;
export type MyLoyaltyStatusSidebarQueryResult = Apollo.QueryResult<MyLoyaltyStatusSidebarQuery, MyLoyaltyStatusSidebarQueryVariables>;